// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Form, Image, Container, Segment, Button, Grid } from 'semantic-ui-react'
import fire from '../config/Fire'

export default class ManageWooCommerce extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true
    }
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  componentDidMount = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        let raw = user.email
        let userUnderscore = raw.replace(/\./g, '_')
        this.setState({
          userUnderscore: userUnderscore
        })
        this.userData()
      } else {
        this.props.history.push('/')
      }
    })
  }

  userData = (e) => {
    fetch('https://murkstomstag.herokuapp.com/api/v1/user/data', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((obj) => {
        if ((obj.code = 200)) {
          this.setState({
            storeurl: obj.storeurl,
            consumerkey: obj.consumerkey,
            consumersecret: obj.consumersecret,
            loading: false
          })
        } else {
          this.setState({
            loading: false,
            error: 'Internal Server Error |  code 500'
          })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  edit = (e) => {
    e.preventDefault()
    this.setState({ loading: true })
    const objUpdate = {
      storeurl: this.state.storeurl,
      consumerkey: this.state.consumerkey,
      consumersecret: this.state.consumersecret
    }
    const cloneObjUpdate = { ...objUpdate }
    Object.keys(objUpdate).forEach((key) => {
      if (!cloneObjUpdate[key]) cloneObjUpdate[key] = null
    })
    fetch('https://murkstomstag.herokuapp.com/api/v1/add/woocommerce', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore,
        cloneObjUpdate: cloneObjUpdate
      })
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ loading: false, saved: true, saving: false })
        } else {
          this.setState({ error: 'Internal Server Error |  code 500', loading: false })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }
  render () {
    let { storeurl, consumerkey, consumersecret, loading, error, saved } = this.state
    return (
      <Container className='masterdiv'>
        <div className='mb center'>
          <Image
            centered
            style={{ height: '50px' }}
            src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTXNqEAFYlAc4_AGqHK68i5FLAeL_reBJ5cMwXO0IUpBj63LUZx&s'
          />
          <h2>Manage WooCommerce Store</h2>
        </div>

        <Grid reversed='mobile' centered stackable verticalAlign='middle' fluid={true}>
          <Grid.Column width='2' />
          <Grid.Column width='8'>
            <div className='screen-card'>
              <Segment basic padded>
                <div className='mts'>
                  <h3>To create API keys:</h3>
                  <div style={{ fontSize: 16 }}>
                    <p>Go to: WooCommerce > Settings > Advanced > REST API.</p>
                    <li>Select Add Key.</li>
                    <li> Add a Description.</li>
                    <li>Select the User in the dropdown.</li>
                    <li>Select API level of access — Read access only.</li>
                    <li>Select Generate API Key</li>
                  </div>
                  <br />
                  <Button
                    compact
                    style={{ backgroundColor: '#74A2D7', color: '#fff' }}
                    target='_blank'
                    rel='noopener noreferrer'
                    href='https://docs.woocommerce.com/document/woocommerce-rest-api/'>
                    Learn more
                  </Button>
                </div>
              </Segment>
            </div>
          </Grid.Column>
          <Grid.Column width='6'>
            <div className='screen-card'>
              <Segment fluid basic>
                <Form>
                  <Form.Input
                    label='Store URL'
                    type='text'
                    onChange={this.handleChange}
                    value={storeurl}
                    name='storeurl'
                    value={storeurl}
                  />
                  <Form.Input
                    label='Consumer Key'
                    type='text'
                    onChange={this.handleChange}
                    value={consumerkey}
                    name='consumerkey'
                    value={consumerkey}
                  />
                  <Form.Input
                    label='Consumer Secret'
                    type='text'
                    onChange={this.handleChange}
                    value={consumersecret}
                    name='consumersecret'
                    placeholder={consumersecret}
                  />
                  <Form.Button
                    loading={loading}
                    error={error}
                    content={!saved ? 'Submit' : 'Saved successfully!'}
                    onClick={this.edit}
                    color={!saved ? 'black' : 'green'}
                  />
                </Form>
              </Segment>
            </div>
          </Grid.Column>
          <Grid.Column width='2' />
        </Grid>
      </Container>
    )
  }
}
